import Vapi from 'vuex-rest-api';

const fetcherAdminNetwork = new Vapi({
  state: {
    fetcherAdminNetwork: {
      id: 0,
    },
  },
})
  .get({
    action: 'getFetcherAdminNetwork',
    property: 'fetcherAdminNetwork',
    path: ({ nid }) => `/api/fetcher/admin/networks/${nid}`,
  })
  .getStore();

export default fetcherAdminNetwork;
